(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = [];
  var ticking = false;

  function updateParallax() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    sections.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / vh;
      var translate = Math.max(-18, Math.min(18, progress * -16));
      el.style.setProperty('--parallax-y', translate.toFixed(2) + 'px');
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  function init() {
    sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section'));
    if (!sections.length) return;

    sections.forEach(function (el, i) {
      el.classList.add('reveal-on-scroll');
      el.style.transitionDelay = (Math.min(i, 3) * 60) + 'ms';
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            el.classList.add('is-visible');
            io.unobserve(el);
            window.setTimeout(function () {
              el.classList.add('is-settled');
            }, 850);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      sections.forEach(function (el) { io.observe(el); });
    } else {
      sections.forEach(function (el) { el.classList.add('is-visible', 'is-settled'); });
    }

    updateParallax();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
